import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Flex } from "@radix-ui/themes";
import { useGateValue } from "@statsig/react-bindings";

import ContainerWrapper from "@/components/ui/ContainerWrapper";
import FilterSection from "@/components/Marketplace/FilterSection";
import LegacyMarketplace from "@/components/Marketplace/LegacyMarketplace";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { marketplaceSearchSchema } from "./-search";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/marketplace/_layout")({
  validateSearch: marketplaceSearchSchema,
  component: MarketplaceLayout,
  // No canonical here: it is a layout route, and the leaf routes below declare
  // their own. Two active matches declaring one would emit two canonicals.
  head: () => ({
    meta: [
      { title: "Marketplace | Lutely" },
      {
        name: "description",
        content:
          "Discover and purchase high-quality music tracks, beats, albums, and soundkits from talented creators around the world on Lutely's Marketplace.",
      },
    ],
  }),
});

function MarketplaceLayout() {
  const newMarketplace = useGateValue("updated_marketplace_ui");
  const isDesktopLayout = useMediaQuery("(min-width: 1024px)");

  if (!newMarketplace) return <LegacyMarketplace />;

  return (
    <ContainerWrapper>
      <Flex
        direction={isDesktopLayout ? "row" : "column"}
        className={cn(
          "w-full self-center justify-self-center",
          isDesktopLayout
            ? "min-h-screen items-start pt-[25px] pb-[150px]"
            : "min-h-screen",
        )}
      >
        {isDesktopLayout && <FilterSection />}

        <Flex className="flex-1 min-w-0" direction="column">
          <Outlet />
        </Flex>
      </Flex>
    </ContainerWrapper>
  );
}
